import {
    getVueInstance as vue,
} from '@shared/utils/instance';

// Helpers
import {
    isValidCodiceFiscale,
} from '@shared/utils/codiceFiscale';

// Types
import {
    Validation,
} from '@shared/validations';

export const codiceFiscaleFormat: Validation = (codiceFiscale: string) => isValidCodiceFiscale(codiceFiscale) ||
    vue().$t('kycDocumentTypes.codiceFiscaleFormatError');

export const validExpiryDate: Validation = (date: string) => (new Date(date) < new Date('01-01-2100')) ||
    vue().$t('kycDocumentTypes.invalidExpiryDate');

export const amlAmountFormat: Validation = (amount: string) => ((/^([1-9]\d{0,9}|0)$/g).test(amount) && parseInt(amount) <= 1000000000) ||
    vue().$t('userAMLQuestionnaire.thirdStep.errorMessage');

export const validNumber: Validation = (amount) => (/^\d+$/).test(amount) || vue().$t('errors.invalidAmount');

export const ukPercentageFormat: Validation = (amount: string) => (
    (parseFloat(amount) >= 0 && parseFloat(amount) < 10)
) || vue().$t('jurisdictionRequirements.ukSelfCategorisation.errorPercentageMessage');

export const ukIncomeFormat: Validation = (amount: string) => ((/^\d+(\.\d{1,2})?$/).test(amount) && parseFloat(amount) >= 100000) ||
    vue().$t('jurisdictionRequirements.ukSelfCategorisation.errorIncomeMessage');

export const ukNetAssetsFormat: Validation = (amount: string) => ((/^\d+(\.\d{1,2})?$/).test(amount) && parseFloat(amount) >= 250000) ||
    vue().$t('jurisdictionRequirements.ukSelfCategorisation.errorNetAssetsMessage');